/**
 * Shield impact: a hexagonal ripple over the hull silhouette for 0.3 s (style guide §3.6).
 * Asset-lane owned (task A11). P0 STUB: no visual.
 */
import type { ModelInstance } from '../../assets/loader'
import type { MaterialLibrary } from './library'

export interface ShieldFx {
  /** Impact point in asset space and strength 0..1. Allocation-free. */
  hit(localX: number, localY: number, localZ: number, strength: number): void
  dispose(): void
}

export function attachShieldFx(lib: MaterialLibrary, instance: ModelInstance): ShieldFx {
  void lib
  void instance
  return { hit: (): void => {}, dispose: (): void => {} }
}
